import styled from "styled-components";

export const MainPageTitle = styled.p`
    margin-bottom: 18px;
    color: #303030;
    font-weight: bold;
    font-size: 42px;
    text-align: center;
    width: 100%;

    @container comparisonTableWrapper (width < 725px) {
        font-size: 28px;
        margin-bottom: 10px;
    }

    @container comparisonTableWrapper (width < 470px) {
        font-size: 18px;
        margin-bottom: 6px;
    }
`;

export const PageExplainer = styled.p`
    color: #303030;
`;

export const CTaxPropertySelect = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border: 2px solid black;
    border-radius: 8px;
    padding: 4px 8px;
    margin-block: 2px;
    margin-inline: auto;
    min-width: 70%;
    background-color: #F9F9FE;
    transition: scale 0.15s ease, background-color 0.15s ease;

    &:hover {
        background-color: #D4DCFD;
        scale: 1.04;
    }

    &.selected {
        background-color: #FFB040;
        scale: 1.1;
    }

    &:hover.selected {
        scale: 1.14;
    }
`;

export const CTaxBandSelect = styled.div`
    display: inline-block;
    border: 2px solid black;
    border-radius: 8px;
    padding; 4px 8px;
    margin: 10px;
    width: 80px;
    aspect-ratio: 1;
    background-color: #F9F9FE;
    transition: scale 0.15s ease, background-color 0.15s ease;
    font-size: 32px;

    &:hover {
        background-color: #D4DCFD;
        scale: 1.04;
    }

    &.selected {
        background-color: #FFB040;
        scale: 1.2;
    }

    &:hover.selected {
        scale: 1.25;
    }
`

export const ImageOptionTile = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid black;
    border-radius: 10px;
    width: 250px;
    height: 180px;
    overflow: hidden;
    background-color: #F9F9FE;
    transition: scale 0.15s ease, background-color 0.15s ease;

    &:hover {
        background-color: #D4DCFD;
        scale: 1.04;
    }

    &.selected {
        background-color: #FFB040;
        scale: 1.1;
    }

    &:hover.selected {
        scale: 1.14;
    }
`;

export const GenerateReportProgressMeterWrapper = styled.div`
    container: meterWrapper / inline-size;
    display: flex;
    margin-inline: auto;
    container-type: inline-size;
    width: 100%;
    max-width: 1200px;
`;

export const GenerateReportProgressMeter = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;

    .step {
        display: flex;
        border: 2px solid #C0C0C0;
        border-radius: 50%;
        height: 100px;
        width: 100px;
        padding: 10px;
        align-items: center;
        justify-content: center;
        background-color: #F0F0F0;
    }

    .step p {
        text-align: center;
        translate: 0px 6px;
        font-family: Poppins;
        color: #C0C0C0;
    }

    .stepComplete {
        border: 2px solid #00D000;
        background-color: #40E040;
    }

    .stepActive {
        border: 2px solid #C0C000;
        background-color: #FFFF00;
        font-weight: bold;
    }

    .stepComplete p, .stepActive p {
        color: #000000;
    }

    .stepFill {
        height: 10px;
        flex: 1;
        background-color: #F0F0F0;
    }

    .stepFillComplete {
        background-color: #40E040;
    }

    @container meterWrapper (width < 600px) {
        display: none;
    }
`;